module.exports = require("promise-worker");


//////////////////
// WEBPACK FOOTER
// external "promise-worker"
// module id = 498
// module chunks = 0